import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import SoftButton from "components/SoftButton";
import env from "config";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import { useAppServices } from "hook/services";
import { Snackbar } from "@mui/material";
import axios from "axios";

function Domain({
  handelThemeData,
  selectedTheme,
  loading,
  errorMsg,
  successMsg,
  gateway,
  buttonLoading,
  open,
  setOpen,
}) {
  const inputData = selectedTheme?.theme_data?.domain;
  const SERVER_IP = env.SERVER_IP;
  const [openWhitelabelModal, setopenWhitelabelModal] = useState(false);
  const [domainUpdate, setdomainUpdate] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [domain, setDomain] = useState(inputData?.domain?.replace(/^www\./i, "") || null);
  const Service = useAppServices();

  const handleSubmit = async (e, val) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    const formObject = {};
    formData.forEach((value, key) => {
      formObject[key] = value;
    });

    if (formObject.domain) {
      formObject.domain = formObject.domain.replace(/^www\./i, "");
    }

    if (val) {
      formObject.extraValue = val;
    }
    await handelThemeData({ domain: formObject }, setResponseMessage, setOpen);
  };
  
   const handleReInstall = async () => {
  try {
    const payload = {
      domain: domain.replace(/^www\./i, ""),
    };

    const response = await axios.post(
      `https://backendapi.smartdirectory.ai/api/v1/agency/ReinStallDomainSSl`,
      payload,
      {
        timeout: 180000, // 3 minutes - SSL installation can take a long time
      }
    );

     // check response data
     if (response?.data) {
      if (response.data.success === true) {
        setResponseMessage(response.data.message || "SSL Reinstall successfully");
      } else {
        setResponseMessage(response.data.message || "SSL Reinstall request failed");
      }
    } else if (response?.status >= 200 && response?.status < 300) {
      setResponseMessage("SSL Reinstall successfully");
    } else {
      setResponseMessage("SSL Reinstall request failed");
    }
  } catch (error) {
    console.error("Reinstall failed:", error);

    // If response data exists, use message from server
    if (error?.response?.data?.message) {
      setResponseMessage(error.response.data.message);
    } 
    // Handle timeout - SSL installation can take a long time
    else if (error?.code === "ECONNABORTED" || error?.message?.includes("timeout")) {
      setResponseMessage("SSL Reinstall is taking longer than expected. Please check server logs.");
    }
    // Handle gateway timeout
    else if (error?.response?.status === 504) {
      setResponseMessage("SSL Reinstall is processing. This may take a few minutes.");
    }
    // Handle network errors
    else if (error?.message?.includes("Network Error")) {
      setResponseMessage("Network error. Please check your connection and try again.");
    }
    // Generic error
    else {
      setResponseMessage(error?.response?.data?.error || error?.message || "SSL Reinstall failed due to an unexpected error");
    }
  } finally {
    setOpen(true);
  }
};


  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        message={responseMessage || "Theme Updated Successfully"}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />

      <SoftBox component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          <Grid item xs={12} className="zeroBtmP" style={{ marginTop: "20px" }}>
            <SoftTypography variant="h5">White Labeling</SoftTypography>
          </Grid>
          <Grid item xs={12} className="px-2">
            <FormField
              label="Enter your Domain"
              placeholder="domain"
              name="domain"
              inputProps={{ type: "domain" }}
              defaultValue={inputData?.domain?.replace(/^www\./i, "")}
              onChange={(e) => {
                setDomain(e.target.value);
                setdomainUpdate(true);
              }}
            />

            <input type="hidden" name="domain_update" value={domainUpdate} />
            {errorMsg !== "" && (
              <small style={{ color: "red" }}>
                {errorMsg}
                {/* Domain not configured! Your A name record might not be updated yet. Please resubmit
                your domain after some time! */}
              </small>
            )}

            {successMsg && (
              <small style={{ color: "green" }}>Domain is configured successfully.</small>
            )}
            {gateway && (
              <small style={{ color: "green" }}>Domain is configured successfully.</small>
            )}
          </Grid>

          <Grid item xs={12} className="px-2" display="flex" justifyContent={"space-between"}>
            <button
              className="btn-new-design-black"
              type="button"
              onClick={() => setopenWhitelabelModal(true)}
            >
              Domain Connection Info
            </button>
            <div>
              <button
                className="btn-new-design-black"
                // type="submit"
                disabled={buttonLoading}
              >
                {buttonLoading ? "Loading..." : " Update"}
              </button>
              <button
                className="btn-new-design-black"
                style={{ margin: "0px 20px" }}
                type="button"
                // disabled={buttonLoading}
                onClick={() => handleReInstall()}
              >
                {"ReInstall SSL"}
              </button>
            </div>
          </Grid>
          {openWhitelabelModal && (
            <div className="modal-zz-confirm">
              <div
                className="scrollable-modal-content bg-white  rounded"
                style={{ border: "1px solid black ", position: "relative" }}
              >
                <h2 className="text-center font-14">Connect white label domain</h2>
                <span className="crossison" onClick={() => setopenWhitelabelModal(false)}>
                  X
                </span>
                <div className="list-model0">
                  <p>
                    Connect your own domain to the system, you can use any domain you own for this.
                    Do not include (https://). For example: directory.yourdomain.com
                  </p>
                  <p>
                    {" "}
                    You can use any domain you own or you can create a sub-domain like
                    directory.yourdomain.com to get white-labeled access to the platform.
                  </p>
                  <ul>
                    <li className="listtext">
                      <b>1.</b> choose your desired domain zone from your domain registrar&apos;s
                      control pannel.
                    </li>

                    <li className="listtext">
                      {" "}
                      <b>2.</b>Create a record of{" "}
                      <u>
                        <b>ANAME</b>
                      </u>{" "}
                      type by entering your domain/subdomain name and pointing it to{" "}
                      <u>
                        <b>{SERVER_IP}</b>
                      </u>{" "}
                    </li>
                    <li className="listtext">
                      {" "}
                      <b>3.</b> We will do the rest!{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Grid>
      </SoftBox>
    </div>
  );
}

export default Domain;
